import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';
import 'react-toastify/dist/ReactToastify.css';
import originalFetch from 'isomorphic-fetch';


class UserAnalysisService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.USER_ANALYSIS = '/api/user-analysis';

        this.GET_BY_ASSIGNEE = '/assignee/{assigneeUserId}';
        this.GET_BY_TEAM_AND_PROJECT_LIST = '/team/projects';
    }

    async getUserAnalysisByAssigneeUserId(assigneeUserId) {
        let url = window.location.origin + this.USER_ANALYSIS + this.GET_BY_ASSIGNEE;
        url = url
            .replace('{assigneeUserId}', assigneeUserId);
        try {
            const releaseDataRet = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return releaseDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getUserAnalysisByTeamAndProjectIdList(requestMap) {
        try {
            let url = window.location.origin + this.USER_ANALYSIS + this.GET_BY_TEAM_AND_PROJECT_LIST;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const userList = this.fetch(url,{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(requestMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }
}

export default UserAnalysisService;